import { useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Logo from '../components/Logo'
import { USING_MOCK } from '../services/api'

export default function AdminLogin() {
  const { isAuthed, login } = useAuth()
  const nav = useNavigate()
  const loc = useLocation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  if (isAuthed) return <Navigate to="/admin" replace />

  const submit = async (e) => {
    e.preventDefault()
    setBusy(true)
    setError('')
    try {
      await login(email.trim(), password)
      nav(loc.state?.from || '/admin', { replace: true })
    } catch (err) {
      setError(err.message || 'Login failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="adm adm--center">
      <div className="adm__loginwrap">
      <form className="adm__card adm__login" onSubmit={submit}>
        <div className="adm__loginlogo"><Logo /></div>
        <h1>Admin login</h1>
        {USING_MOCK && <p className="adm__hint">Demo: admin@ipoint.com / admin123</p>}
        <label>Email
          <input type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label>Password
          <input type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <p className="adm__error" role="alert">{error}</p>}
        <button className="adm__btn" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      </form>
      </div>
    </div>
  )
}